// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"DropdownNavigation_buttonsWrapper__Kko40","button":"DropdownNavigation_button__LGzvT","flex":"DropdownNavigation_flex__3Y-L-"};